import BaseFieldModel from "@/core/components/input-widget/BaseFieldModel";


const APPENDABLE_CHOICE_FIELD_NAME = 'AppendableChoiceField';
const MULTIPLE_CHOICE_FIELD_NAME = 'MultipleChoiceField';
const MAIN_FIELD = 'MainField';

export default class DynamicFieldModel extends BaseFieldModel {
  rules = {}
  type = null
  key = null
  label = null
  field_class_name = null
  char_counter = false
  depends_on = null
  math_calculate = null

  constructor(data = {}) {
    super()
    Object.assign(this, {...data});
  }

  getChoices(localeKey) {
    if (this.rules && this.rules.choices) {
      // TODO remove this if statement once choice fields become translatable too
      if (this.field_class_name === APPENDABLE_CHOICE_FIELD_NAME) {
        return this.rules.choices.filter(choice => choice.key[localeKey]).map(choice => ({
          'key': choice.key[localeKey],
          'value': choice.value
        }));
      } else if (this.isMainField()) {
        return this.rules.choices.filter(choice => choice.data[localeKey]).map(choice => ({
          data: choice.data,
          id: choice.data[localeKey][this.key],
          text: choice.data[localeKey][this.key]
        }));
      }
      return this.rules.choices;
    }
    return [];
  }

  isAppendable() {
    return this.field_class_name === APPENDABLE_CHOICE_FIELD_NAME;
  }

  isMultiple() {
    return this.field_class_name === MULTIPLE_CHOICE_FIELD_NAME;
  }

  isMainField() {
    return this.field_class_name === MAIN_FIELD;
  }

  addChoice(localeKey, newValue) {
    if (this.isAppendable()) {
      this.rules.choices.unshift({
        'key': {
          [localeKey]: newValue.value
        },
        'value': newValue.id,
        'isNew': true,
      });
    } else if (this.isMainField()) {
      if (!this.rules.choices) {
        this.rules.choices = [];
      }
      this.rules.choices.unshift({
        data: newValue.data
      });
    }
  }

  isNewChoice(value) {
    let choice = this.rules.choices.find(choice => choice.value === value);
    return choice && choice.isNew;
  }

  hasCharCounter() {
    return ['text', 'ckeditor', 'textarea'].includes(this.type) && this.char_counter;
  }
}
